import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    importdata(ctx, xdata) {
      console.log(xdata)
      return new Promise((resolve, reject) => {
        axios
          .post(xdata.url, xdata.data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
}}
